module.exports = __webpack_public_path__ + "img/hr-garballo-06.2e68178b.png";